import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import { ContractSaleSearchResultsProps } from "./types";
import { useTranslate } from "helpers";
import { CONTRACT_SALE_SEARCH_COLUMNS } from "./consts";


const ContractSaleSearchResults: React.FC<
  ContractSaleSearchResultsProps
> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onVehicleClick,
    onContactClick,
    onDeleteClick,
  } = props;

  const { t } = useTranslate();
  return (
    <>
      <TableSearch
        columns={CONTRACT_SALE_SEARCH_COLUMNS(t, onVehicleClick, onContactClick, onDeleteClick)}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}


      />
    </>
  );
};
export default memo(ContractSaleSearchResults);
